"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _reactColor = require("react-color");

var _CurrentContext = _interopRequireDefault(require("../context/CurrentContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    right: 0;\n    top: 20px;\n    z-index: 10;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    width: 18px;\n    height: 18px;\n    border: 2px solid #fff;\n    background-color: ", ";\n    border-radius: 50%;\n    cursor: pointer;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var MainContainer = _styledComponents.default.div(_templateObject());

var Container = _styledComponents.default.div(_templateObject2());

var Swatch = _styledComponents.default.div(_templateObject3(), function (_ref) {
  var color = _ref.color;
  return color || '#fff';
});

var PickerWrapper = _styledComponents.default.div(_templateObject4());

var ColorPicker =
/*#__PURE__*/
function (_Component) {
  _inherits(ColorPicker, _Component);

  function ColorPicker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ColorPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ColorPicker)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      opened: false
    };

    _this.toggle = function () {
      return _this.setState(function (prev) {
        return {
          opened: !prev.opened
        };
      });
    };

    _this.close = function () {
      return _this.setState({
        opened: false
      });
    };

    _this.onChange = function (_ref2, onChange) {
      var rgb = _ref2.rgb;
      var prop = _this.props.prop;
      onChange(prop, "rgba(".concat(rgb.r, ", ").concat(rgb.g, ", ").concat(rgb.b, ", ").concat(rgb.a, ")"));
    };

    _this.renderPicker = function (_ref3) {
      var current = _ref3.current,
          onChangeProp = _ref3.onChangeProp,
          onChangeSettingsProp = _ref3.onChangeSettingsProp,
          settings = _ref3.settings;
      var prop = _this.props.prop;
      var opened = _this.state.opened;
      var item = current || settings;
      return _react.default.createElement(MainContainer, null, _react.default.createElement(Container, null, _react.default.createElement(Swatch, {
        color: item[prop],
        onClick: _this.toggle
      }), opened && _react.default.createElement(PickerWrapper, null, _react.default.createElement(_reactClickOutside.default, {
        onClickOutside: _this.close
      }, _react.default.createElement(_reactColor.SketchPicker, {
        color: item[prop],
        onChange: function onChange(color) {
          return _this.onChange(color, current ? onChangeProp : onChangeSettingsProp);
        }
      })))));
    };

    return _this;
  }

  _createClass(ColorPicker, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_CurrentContext.default.Consumer, null, this.renderPicker);
    }
  }]);

  return ColorPicker;
}(_react.Component);

exports.default = ColorPicker;
ColorPicker.propTypes = {
  prop: _propTypes.default.string
};
ColorPicker.defaultProps = {
  prop: 'fill'
};